import { Autocomplete, TextField } from "@mui/material"
import { useCallback, useEffect, useState } from "react";
import { Controller, UseFormReturn } from "react-hook-form";
import { useDependencyInjection } from "../../config/di/dependency_injection_context";
import { DropDown } from "../domain/models/dropdown";

/**
 * DropDownunidade
 */

type Props<F extends {}> = {
  name: keyof F,
  idCentroCusto: number | null,
  idCliente: number | null,
  label?: string,
  required?: boolean,
  readOnly?: boolean,
  placeholder?: string,
  reactHookForm: UseFormReturn<F>,

};

export const DropDownUnidade = <F extends {},>({
  name,
  idCentroCusto,
  idCliente,
  required,
  readOnly,
  label = "Unidade",
  placeholder,
  reactHookForm,

}: Props<F>) => {

  const [unidadeDropDown, setUnidadeDropDown] = useState<DropDown[]>([]);

  const {
    commons: {
      getUnidadesDropDownUseCase,
    }

  } = useDependencyInjection();

  const loadUnidadesDropDown = useCallback(async (idCentroCusto?: number | null) => {
    try {
      const result = await getUnidadesDropDownUseCase.getUnidadesDropDown();

      const filteredResult = result.filter(x => {
        if (idCentroCusto && x.idCentroCusto !== idCentroCusto) return false;
        if (idCliente && x.idCliente !== idCliente) return false;
        return true;
      });

      setUnidadeDropDown(filteredResult);

    } catch (e: unknown) {
      throw new Error('Falha ao buscar unidades!');
    }
  }, [
    idCliente,
    getUnidadesDropDownUseCase,
  ]);

  useEffect(() => {

    if (idCentroCusto !== undefined && idCentroCusto !== null) {
      (async () => {
        await loadUnidadesDropDown(idCentroCusto);
      })();
    } else {
      (async () => {
        await loadUnidadesDropDown();
      })();
    }
  }, [loadUnidadesDropDown, idCentroCusto]);

  return (
    <>
      {/*Centro Custo DropDown */}
      <Controller
        name={name as any}
        control={reactHookForm.control}
        render={({ field, formState }) => {
          let helperText: string | null = null;

          if (formState.errors[name as keyof typeof formState.errors]) {
            const fieldError = formState.errors[name] as any;
            if (fieldError?.message && typeof fieldError.message === 'string') {
              helperText = fieldError.message;
            }
          }

          return (
            <Autocomplete
              fullWidth={true}
              size="small"
              disablePortal
              options={unidadeDropDown}
              getOptionKey={opt => opt.id}
              getOptionLabel={(opt) => opt.title}
              isOptionEqualToValue={(opt, val) => opt.id === val.id}
              sx={{ minHeight: 45 }}
              readOnly={readOnly}
              disabled={formState.disabled}
              value={unidadeDropDown.find(x => x.id === field.value) ?? null}
              onChange={(_, newValue) => field.onChange(newValue ? newValue.id : undefined)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  size="small"
                  label={label}
                  error={helperText !== null}
                  helperText={helperText}
                  placeholder={placeholder}
                  required={required}
                />
              )}
            />
          );
        }}
      />


    </>
  );
};
